import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

type Entry = templates.SiteMapDocumentTemplate["entries"][number];

interface SiteMapNode {
    title: string;
    url: string;
    children: SiteMapNode[];
}

// Rebuild the nested page tree from the flat (title, url, depth) rows. Each node
// attaches to the nearest preceding node of smaller depth, so any depth
// numbering the treebeard annotation produces nests correctly.
const buildTree = (entries: readonly Entry[]): SiteMapNode[] => {
    const roots: SiteMapNode[] = [];
    const stack: { depth: number; node: SiteMapNode }[] = [];
    for (const entry of entries) {
        const node: SiteMapNode = {
            title: entry.title,
            url: entry.url,
            children: [],
        };
        while (
            stack.length > 0 &&
            stack[stack.length - 1].depth >= entry.depth
        ) {
            stack.pop();
        }
        if (stack.length === 0) {
            roots.push(node);
        } else {
            stack[stack.length - 1].node.children.push(node);
        }
        stack.push({ depth: entry.depth, node });
    }
    return roots;
};

const SiteMapList = ({
    nodes,
}: {
    nodes: readonly SiteMapNode[];
}): React.JSX.Element => (
    <ul>
        {nodes.map((node, i) => (
            <li key={i}>
                <a href={node.url}>{node.title}</a>
                {node.children.length > 0 && (
                    <SiteMapList nodes={node.children} />
                )}
            </li>
        ))}
    </ul>
);

export const Template = (
    props: templates.SiteMapDocumentTemplate,
): React.JSX.Element => {
    const tree = buildTree(props.entries);
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width sitemap">
                <div>
                    <h2>Sitemap</h2>
                </div>
                <div className="sitemap__links">
                    <SiteMapList nodes={tree} />
                </div>
            </div>
        </PageSkeleton>
    );
};
